
/**社会保险补贴基本信息 */
import {
  inputObj,
  datePickerObj,
  // checkBox,
  chooseObj
} from "utils/getObjs";
import { monthOptions } from "utils/constant";

const basicInformation = [
  datePickerObj("申报年度", "applyYear", true, false),
  // chooseObj("申报起始月份", "startDate", true,false),
  // chooseObj("申报结束月份", "endDate", true,false),
  {
    ...chooseObj('申报起始月份', 'startDate', true),
    option: [monthOptions],
  },
  {
    ...chooseObj('申报结束月份', 'endDate', true),
    option: [monthOptions],
  },
  // {
  //   infoType: 'verificationCode',
  //   postName: 'FPHONE',
  //   codePostName: 'authCode',
  //   label: '手机号码',
  //   codeLabel: '验证码',
  //   message: '请输入联系手机',
  //   codeMessage: '请输入验证码',
  //   required: true,
  //   disabled: false,
  //   time: 180,
  // },
  inputObj("姓名", "username", true, true),
  inputObj("年龄", "age", true, true),
  inputObj('性别', 'gender', true, true),
  inputObj("社保卡金融帐户卡号", "FBANKNUM", true),
];
const explainInformation = [
  inputObj("补贴对象类型", "personType", false, true),
  //checkBox('')
]
export const socialSecurityPage1 = [
  { title: "", arr: basicInformation, key: 'social' },
  { explain: "说明：社保补贴待遇发放将通过您的社保卡金融账户发放，请认真核对您的社保卡金融账户银行卡号，以免造成待遇发放错误，如果您的社保无金融功能，请先去做有银行金融功能的社保卡！", arr: explainInformation, key: 'social' },
  { explain: '', arr: [], key: 'info' },
];
